import type { Category } from "@/types/comic";

export const categories: Category[] = [
  {
    slug: "rexue",
    name: "热血",
    icon: "ri-fire-line",
    description: "少年逆袭、友情与成长，燃到最后一页的战斗与信念，最适合一口气追完的经典题材。",
  },
  {
    slug: "lianai",
    name: "恋爱",
    icon: "ri-heart-3-line",
    description: "从初见到心动，细腻描绘青春与情感的甜蜜日常，让人忍不住一读再读。",
  },
  {
    slug: "qihuan",
    name: "奇幻",
    icon: "ri-magic-line",
    description: "魔法、异界、神兽与传说，构建庞大而迷人的幻想世界，想象力拉满。",
  },
  {
    slug: "xiaoyuan",
    name: "校园",
    icon: "ri-graduation-cap-line",
    description: "教室、社团与放课后的青春物语，熟悉的校园场景里藏着最真挚的故事。",
  },
  {
    slug: "xuanyi",
    name: "悬疑",
    icon: "ri-shield-keyhole-line",
    description: "层层反转的线索与谜题，跟随主角一步步揭开真相，越看越上头。",
  },
  {
    slug: "kehuan",
    name: "科幻",
    icon: "ri-rocket-2-line",
    description: "星际、机甲与未来科技，以严谨设定呈现宏大的宇宙想象与人性思考。",
  },
  {
    slug: "gaoxiao",
    name: "搞笑",
    icon: "ri-emotion-laugh-line",
    description: "密集笑点与夸张演出，工作学习之余的快乐解压首选。",
  },
  {
    slug: "maoxian",
    name: "冒险",
    icon: "ri-compass-3-line",
    description: "未知地图、危险旅程与伙伴同行，一路向前探索世界尽头的秘密。",
  },
  {
    slug: "richang",
    name: "日常",
    icon: "ri-sun-line",
    description: "温暖治愈的生活片段，平凡日子里的小确幸，看着就很放松。",
  },
  {
    slug: "kongbu",
    name: "恐怖",
    icon: "ri-ghost-2-line",
    description: "诡异氛围与心理惊悚，胆量挑战者的深夜必读清单。",
  },
];